
import { OpDistributor } from '../core/op-distributor'

export class ActiveDistributorInfo {
    public distributor: OpDistributor
    public isActive: boolean

    constructor(distributor: OpDistributor, isActive: boolean) {
        this.distributor = distributor
        this.isActive = isActive
    }
}